import { api } from "@/lib/http.ts";
import type { BrowserLoginClient } from "@/shared/browserLogin.ts";
import type {
  BrowserLoginMetadata,
  SaveBrowserLogin,
  SaveBrowserLoginResponse,
  ForgetBrowserLoginResponse,
} from "@/types/browserLogin.ts";

export const browserLoginClient: BrowserLoginClient = {
  metadata: async (origin, signal) =>
    (
      await api.get<BrowserLoginMetadata>("/api/a/website-sign-ins/credentials", {
        params: { origin },
        signal,
      })
    ).data,
  save: async (request) => {
    await api.put<SaveBrowserLoginResponse, SaveBrowserLogin>(
      "/api/a/website-sign-ins/credentials",
      request,
    );
  },
  forget: async (request) => {
    await api.delete<ForgetBrowserLoginResponse>("/api/a/website-sign-ins/credentials", {
      data: request,
    });
  },
};
